import { render, staticRenderFns } from "./AddRenameProjectAddUser.vue?vue&type=template&id=484be4fa"
import script from "./AddRenameProjectAddUser.vue?vue&type=script&lang=js"
export * from "./AddRenameProjectAddUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports